import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import DownloadFile from '@/core/utils/DownloadFile'

export default {
	[actionTypes.ANUENCIA.DOCUMENTOS.BAIXAR_DOCUMENTO_ANEXO]: async (context, documento) => {
		const response = await api.documentosAnuencia.baixar(documento)
		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
}
